(function(angular, module) {var TagListController, tagListDirective,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

TagListController = (function() {

  /* @ngInject */
  function TagListController($scope, $document, $element, $timeout, TagService) {
    this.updateParams = bind(this.updateParams, this);
    this.documentKeyUp = bind(this.documentKeyUp, this);
    this.documentClick = bind(this.documentClick, this);
    this.close = bind(this.close, this);
    var ref;
    this.TagService = TagService;
    this.scope = $scope;
    this.timeout = $timeout;
    this.document = $document;
    this.element = $element;
    this.isOpen = false;
    this.tags = this.tags || [];
    this.params = this.params || {};
    this.urlListController = $element.controller('dybUrlTagLists');
    if (this.urlListController) {
      if (this.programId == null) {
        this.programId = (ref = this.urlListController.program) != null ? ref.id : void 0;
      }
      this.urlListController.addTagList(this);
      this.scope.$on('$destroy', (function(_this) {
        return function() {
          return _this.urlListController.addTagList(_this);
        };
      })(this));
    }
    this.scope.$watchCollection(((function(_this) {
      return function() {
        return _this.tags;
      };
    })(this)), this.updateParams);
  }

  TagListController.prototype.toggleOpen = function() {
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  };

  TagListController.prototype.loadTags = function(params) {
    return this.TagService.lookupTags(params, this.root).then((function(_this) {
      return function(tags) {
        return _this.tags = tags;
      };
    })(this));
  };

  TagListController.prototype.open = function() {
    this.isOpen = true;
    this.element.addClass('open');
    this.timeout((function(_this) {
      return function() {
        _this.document.bind("click", _this.documentClick);
        return _this.document.bind("keyup", _this.documentKeyUp);
      };
    })(this));
  };

  TagListController.prototype.close = function() {
    this.isOpen = false;
    this.element.removeClass('open');
    this.document.unbind("click", this.documentClick);
    this.document.unbind("keyup", this.documentKeyUp);
  };

  TagListController.prototype.documentClick = function(event) {
    var inList, inPicker, ref, ref1;
    inPicker = (ref = this.element.find('dyb-tag-picker')[0], indexOf.call(event.path, ref) >= 0);
    inList = (ref1 = this.element[0].querySelector('ul.tags'), indexOf.call(event.path, ref1) >= 0);
    if (!(inPicker || inList)) {
      this.scope.$apply(this.close);
    }
  };

  TagListController.prototype.documentKeyUp = function(event) {
    if (event.keyCode === 27) {
      this.scope.$apply(this.close);
      return event.preventDefault();
    }
  };

  TagListController.prototype.addTag = function(tag) {
    return this.tags.push(tag);
  };

  TagListController.prototype.removeTag = function(tag) {
    var index;
    index = this.tags.indexOf(tag);
    if (index >= 0) {
      return this.tags.splice(index, 1);
    }
  };

  TagListController.prototype.updateParams = function(tags) {
    var i, len, newParams, tag;
    newParams = {};
    for (i = 0, len = tags.length; i < len; i++) {
      tag = tags[i];
      newParams[tag.slug] = newParams[tag.slug] || [];
      newParams[tag.slug].push(tag.value);
    }
    angular.copy(newParams, this.params);
    if (this.urlListController) {
      this.urlListController.paramsChanged(this, this.params);
    }
  };

  return TagListController;

})();


/* @ngInject */

tagListDirective = function() {
  return {
    restrict: 'E',
    templateUrl: 'util/tags/list',
    scope: {},
    controller: TagListController,
    controllerAs: 'ctrl',
    bindToController: {
      programId: '=',
      root: '@',
      skip: '@',
      addLabel: '@addLabel',
      label: '@label',
      params: '=',
      tags: '='
    }
  };
};

module.directive('dybTagList', tagListDirective);
})(angular, angular.module("dybTags"));